import { message } from 'antd'
import { generateMessageError } from 'modules/core/utils'
import i18n from 'i18next'

export const handleCellEdit = ({
  updateTransactionPercentage,
  onRefetch,
  setShowAlert,
  sendUserDataToGTM,
}) => {
  message.loading({
    key: 'loading_edit',
    content: i18n.t('FEEDBACK_LOADING_CHANGES'),
  })
  setShowAlert((prevState) => {
    return { ...prevState, percentage: true }
  })
  updateTransactionPercentage()
    .then(() => {
      onRefetch()
      message.destroy('loading_edit')
      message.success(i18n.t('FEEDBACK_SAVE_CHANGES_SUCCES', 8))
      setShowAlert((prevState) => {
        return { ...prevState, percentage: false }
      })
      sendUserDataToGTM()
    })
    .catch((error) => {
      message.error(generateMessageError(error, 'FEEDBACK_DEFAULT_ERROR'), 8)
      setShowAlert((prevState) => {
        return { ...prevState, percentage: false }
      })
    })
}

export const handleApply = ({ applyRdnPercentage, onRefetch, setShowAlert, sendUserDataToGTM }) => {
  message.loading({
    key: 'loading_edit',
    content: i18n.t('FEEDBACK_LOADING_CHANGES'),
  })
  setShowAlert((prevState) => {
    return { ...prevState, percentage: true }
  })
  applyRdnPercentage()
    .then(() => {
      onRefetch()
      message.destroy('loading_edit')
      message.success(i18n.t('FEEDBACK_SAVE_CHANGES_SUCCES', 8))
      setShowAlert((prevState) => {
        return { ...prevState, percentage: false }
      })
      sendUserDataToGTM()
    })
    .catch((error) => {
      message.error(generateMessageError(error, 'FEEDBACK_DEFAULT_ERROR'), 8)
      setShowAlert((prevState) => {
        return { ...prevState, percentage: false }
      })
    })
}

export const handleUnApply = ({
  unApplyRdnPercentage,
  onRefetch,
  setShowAlert,
  sendUserDataToGTM,
}) => {
  message.loading({
    key: 'loading_edit',
    content: i18n.t('FEEDBACK_LOADING_CHANGES'),
  })
  setShowAlert((prevState) => {
    return { ...prevState, percentage: true }
  })
  unApplyRdnPercentage()
    .then(() => {
      onRefetch()
      message.destroy('loading_edit')
      message.success(i18n.t('FEEDBACK_SAVE_CHANGES_SUCCES', 8))
      setShowAlert((prevState) => {
        return { ...prevState, percentage: false }
      })
      sendUserDataToGTM()
    })
    .catch((error) => {
      message.error(generateMessageError(error, 'FEEDBACK_DEFAULT_ERROR'), 8)
      setShowAlert((prevState) => {
        return { ...prevState, percentage: false }
      })
    })
}
